import '@angular/compiler';

import {
  enableProdMode,
  importProvidersFrom,
  inject,
  provideAppInitializer
} from '@angular/core';
import {
  IonicRouteStrategy,
  provideIonicAngular
} from '@ionic/angular/standalone';

import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {bootstrapApplication} from '@angular/platform-browser';
import {
  PreloadAllModules,
  provideRouter,
  RouteReuseStrategy,
  withComponentInputBinding,
  withPreloading
} from '@angular/router';
import {IonicStorageModule} from '@ionic/storage-angular';
import {AppComponent} from './app/app.component';
import {routes} from './app/app.routes';
import {environment} from './environments/environment';
import {RecursosService} from './app/core/services/recursos.service';
import {headerInterceptor} from './app/core/interceptors/header.interceptor';
import {errorInterceptor} from './app/core/interceptors/error.interceptor';
import {ConfigService} from './app/core/services/config.service';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    {provide: RouteReuseStrategy, useClass: IonicRouteStrategy},
    provideIonicAngular(),
    provideRouter(
      routes,
      withPreloading(PreloadAllModules),
      withComponentInputBinding()
    ),
    provideHttpClient(withInterceptors([headerInterceptor, errorInterceptor])),
    importProvidersFrom(IonicStorageModule.forRoot()),
    provideAppInitializer(() => {
      const recursosService = inject(RecursosService);
      return recursosService.cargarRecursos();
    }),
    provideAppInitializer(() => {
      const configService = inject(ConfigService);
      return configService.loadConfig();
    })
  ]
}).catch((err) => console.error(err));
